<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h3 slot="header" class="header text-center">Login</h3>

                <fg-input
                  v-model="form.emailAddress"
                  name="emailAddress"
                  type="email"
                  data-vv-as="email address"
                  data-vv-delay="1000"
                  v-validate="formValidators.emailAddress"
                  :error="fieldError('emailAddress')"
                  addon-left-icon="nc-icon nc-single-02"
                  @keyup.enter="validate"
                  placeholder="Email Address"
                ></fg-input>

                <fg-input
                  v-model="form.password"
                  name="password"
                  v-validate="formValidators.password"
                  data-vv-delay="1000"
                  :error="fieldError('password')"
                  addon-left-icon="nc-icon nc-key-25"
                  @keyup.enter="validate"
                  placeholder="Password"
                  type="password"
                ></fg-input>

                <br>

                <p-checkbox v-model="form.rememberUser">Remember me</p-checkbox>

                <div class="alert alert-warning" v-if="errorMessage">
                  <span>{{ errorMessage }}</span>
                </div>

                <template slot="footer">
                  <p-button
                    v-if="!loggingIn"
                    type="submit"
                    round
                    block
                    class="mb-3"
                    @click.prevent="validate"
                  >
                    Log in &nbsp;
                    <i class="fa fa-arrow-right"></i>
                  </p-button>
                  <p-button v-if="loggingIn" type="info" round block class="mb-3" disabled>
                    <i class="fa fa-spin fa-circle-o-notch"></i>&nbsp; Please wait&hellip;
                  </p-button>
                </template>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background: #F7971E; background: -webkit-linear-gradient(to left, #FFD200, #F7971E); background: linear-gradient(to left, #FFD200, #F7971E);"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
        if (isValid) {
          this.login();
        }
      });
    },
    fieldError(fieldName) {
      // clientside
      if (this.errors.first(fieldName)) {
        return this.errors.first(fieldName);
      }
    },
    login() {
      this.loggingIn = true;
      this.$auth.login({
        data: {
          emailAddress: this.form.emailAddress,
          password: this.form.password
        },
        success: () => {
          this.loggingIn = false;
        },
        error: error => {
          this.loggingIn = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.message) {
              this.errorMessage = error.response.data.message;

              if (error.response.status === 400 && error.response.data.errors) {
                this.validationErrors = error.response.data.errors;
              }
            } else {
              this.errorMessage = "Sorry, an unknown error occurred.";
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest
            this.errorMessage = "Error - no response from server.";
          } else {
            // Something happened in setting up the request that triggered an Error
            this.errorMessage = "Error - request not sent";
          }
        },
        rememberMe: this.form.rememberUser,
        redirect: "/"
      });
    }
  },
  data() {
    return {
      form: {
        emailAddress: "",
        password: "",
        rememberUser: true
      },
      formValidators: {
        emailAddress: {
          required: true,
          email: true
        },
        password: {
          required: true
        }
      },
      validationErrors: {},
      errorMessage: null,
      loggingIn: false
    };
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
</style>
